import React, { useEffect } from 'react';
import './PaymentFailure.css';

const PaymentFailure = ({ reason, onClose }) => {
    useEffect(() => {
        const t = setTimeout(onClose, 5000);
        return () => clearTimeout(t);
    }, [onClose]);

    return (
        <div className="pf-overlay">
            <div className="pf-card">
                <div className="pf-circle">
                    <svg className="pf-icon" viewBox="0 0 52 52">
                        <circle className="pf-icon-circle" cx="26" cy="26" r="25" />
                        <path className="pf-icon-cross1" d="M16 16 L36 36" />
                        <path className="pf-icon-cross2" d="M36 16 L16 36" />
                    </svg>
                </div>
                <p className="pf-title">Payment Failed</p>
                {reason && <p className="pf-reason">{reason}</p>}
                <p className="pf-hint">Please try again or use a different payment method.</p>
                <button className="pf-btn" onClick={onClose}>Try Again</button>
            </div>
        </div>
    );
};

export default PaymentFailure;
